module.exports = __webpack_public_path__ + "img/New Project (8).82a022f8.png";